export default __webpack_public_path__ + "2d01c446795531f2bbee04f7988ca507.png";